import React from 'react'
import { Badge } from '@/shared/ui'
import { Monitor, Smartphone, Share2, PlusSquare } from 'lucide-react'
import { getPlatformInfo } from '@/modules/pwa/utils/platform'

export default function InstallInstructionsContent() {
  const platform = React.useMemo(() => getPlatformInfo(), [])
  const platformLabel = platform.isWindows
    ? 'Windows'
    : platform.isMac
      ? 'macOS'
      : platform.isAndroid
        ? 'Android'
        : platform.isIos
          ? 'iOS'
          : 'Desktop'

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2 text-xs text-foreground/70">
        <span>Sistema detectado:</span>
        <Badge variant="soft" color="info">{platformLabel}</Badge>
      </div>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <div className="rounded-lg border border-border bg-muted/30 p-4">
          <div className="flex items-center gap-2 text-sm font-medium">
            <Monitor className="h-4 w-4" />
            Desktop (Windows e macOS)
          </div>
          <ul className="mt-2 space-y-2 text-sm text-foreground/80">
            <li>Abra o site no Chrome ou Edge.</li>
            <li>Use o icone de instalacao na barra de enderecos.</li>
            <li>Confirme para fixar o app no seu computador.</li>
          </ul>
        </div>

        <div className="rounded-lg border border-border bg-muted/30 p-4">
          <div className="flex items-center gap-2 text-sm font-medium">
            <Smartphone className="h-4 w-4" />
            Android (Chrome ou Edge)
          </div>
          <ul className="mt-2 space-y-2 text-sm text-foreground/80">
            <li>Abra o menu do navegador.</li>
            <li>Toque em "Instalar app".</li>
            <li>Confirme para adicionar na tela inicial.</li>
          </ul>
        </div>
      </div>

      <div className="rounded-lg border border-border bg-muted/30 p-4">
        <div className="flex items-center gap-2 text-sm font-medium">
          <Share2 className="h-4 w-4" />
          iOS (Safari)
        </div>
        <ul className="mt-2 space-y-2 text-sm text-foreground/80">
          <li>Abra o site no Safari.</li>
          <li>Toque em Compartilhar.</li>
          <li className="flex items-center gap-2">
            <PlusSquare className="h-4 w-4 text-foreground/70" />
            Selecione "Adicionar a Tela de Inicio".
          </li>
        </ul>
      </div>
    </div>
  )
}
